import focus from './focus'
import copy from './copy'
import permission from './permission'
import debounce from './debounce'
import throttle from './throttle'


const directives = { // 指令对象
  focus,
  copy,
  permission,
  debounce,
  throttle,
}

export default {
  install(app) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key])
    });
  }
}

